import React, { Component } from "react";
import "../style/login.scss";
import * as LoginAPI from "../apis/LoginAPI";
import cookie from "react-cookies";
import Loading from "./common/Loading";
import Popup from "./common/Popup";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      loadingShow: false,
    };
    this.changeInput = this.changeInput.bind(this);
    this.login = this.login.bind(this);
  }

  changeInput(e, type) {
    switch (type) {
      case "username":
        this.setState({ username: e.target.value });
        break;
      case "password":
        this.setState({ password: e.target.value });
        break;
      default:
        break;
    }
  }

  login() {
    const { username, password } = this.state;
    this.toggleLoading();
    LoginAPI.login(username, password).then((res) => {
      this.toggleLoading();
      var code = res.data.code;
      if (code === 200) {
        var data = res.data.data;
        cookie.save("token", JSON.stringify(data));
        const { history } = this.props;
        history.push("/");
        window.dispatchEvent(
          new CustomEvent("showAlert", {
            detail: "登陆成功",
          })
        );
      }
    });
  }

  toggleLoading() {
    this.setState({ showLoading: !this.state.showLoading });
  }

  render() {
    return (
      <React.Fragment>
        <Popup {...this.props} />
        <Loading {...this.props} loadingShow={this.state.loadingShow} />
        <div className="login-page">
          <div className="login-box">
            <div className="title">Login</div>
            <div className="field">
              <input
                type="text"
                placeholder=""
                onChange={(e) => this.changeInput(e, "username")}
              />
              <div className="placeholder">Username</div>
            </div>
            <div className="field">
              <input
                type="text"
                placeholder=""
                onChange={(e) => this.changeInput(e, "password")}
              />
              <div className="placeholder">Password</div>
            </div>
            <div className="loginBtn" onClick={this.login}>
              Login
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Login;
